<template>
    <div class="m-module">
        <div class="section">
            <div class="page-title">
                {{ $t("lang.announcement") }}
            </div>
            <div class="body">
                <div class="pane">
                    <div class="hd">
                        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                            <van-list  v-model="loading" :finished="finished" finished-text="没有更多了"  @load="onLoad"  >
                                <div v-for="(item, index) in noticeLists" :key="index" >
                                    <el-collapse  accordion  @change="handleChange(item,index)">
                                        <div >
                                            <el-collapse-item >
                                                <template slot="title">
                                                    <div class="navRead" v-if="item.readStatus ==0">{{ $t("lang.Unread") }}</div>
                                                    <div class="nav" v-else>{{ $t("lang.Read") }}</div>
                                                    <div class="title">{{ item.titile }}</div>
                                                </template>
                                                <div v-html="item.msgContent"></div>
                                            </el-collapse-item>
                                        </div>
                                    </el-collapse>
                                </div>
                            </van-list>
                        </van-pull-refresh>
                    </div>
                  
                </div>
            </div>
            <div class="tabbar-placeholder"></div>
            <!-- <div class="tabbar">
                <div class="tabbar-inner u-flex">
                    <div class="u-flex-item u-flex-1">
                        <van-button block round type="primary" @click="subFeedback" >{{ $t("lang.submit") }}</van-button>
                    </div>
                </div>
            </div> -->
        </div>
        <van-popup v-model="popupModel" round :close-on-click-overlay="false"  closeable :style="{ height: '50%',width:'85%' }">
            <div class="popup-mod">
                <div class="hd">
                    <h3 class="title"> {{ $t("lang.feedback") }}</h3>
                </div>
                <van-divider />
                <div class="bd">
                      <div class="field">
                        <van-field  rows="5" autosize :label="$t('lang.feedback')"  type="textarea" maxlength="100" placeholder="请输入问题反馈" show-word-limit/>
                      </div>
                      <van-divider />
                      <!-- <div class="uploader">
                        <van-uploader :after-read="afterRead" />
                      </div> -->
                </div>
                <div class="ft">
                    <div class="form-action">
                        <van-button    size="large"  type="primary" >{{ $t("lang.submit") }}</van-button>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
    </template>
    <script>
    import Header from "@/components/mobile/header";
    import { Toast } from 'vant';
    import {BASE_GLOB_API, BASE_GLOB_DOMAIN} from "@/config.js";
    import {axiosGet, axiosPost} from '@/api/api';
    export default {
        name:'userFeedback-m',
        components: {
            Header,
           
        },
        data(){
            return {
                coinPopup:false,
                url:{
                    notice:BASE_GLOB_API+'/notice/page',
                    detail:BASE_GLOB_API+'/notice/detail',
                },
                lang: "",
                popupModel:false,
                list: [],
                loading: false,
                finished: false,
                refreshing: false,
                noticeLists:[]
               
            }
        },
        mounted(){
          
        },
        created(){
            this.lang = sessionStorage.getItem("Language")
            this.noticeList(1,10)
           
        },
        methods:{
            handleChange(detail,index){
                // console.log("index",index)
                this.noticeLists.splice(index, 1, Object.assign({}, detail, { 'readStatus':1 }))
                // console.log("this.noticeLists",this.noticeLists)
                let params = ''
                axiosGet(this.url.detail+'/'+detail.id,params).then(res=>{
                    if(res.code ==200){
                       
                    }else{
                        this.$message.error(res.message);
                    }
                })
            },
            noticeList(pageNo,pageSize){
                let params = {
                    pageNo:pageNo,
                    pageSize:pageSize
                }
                axiosPost(this.url.notice,params).then(res=>{
                    if(res.code ==200){
                    this.noticeLists =res.result.records
                    }else{
                        this.$message.error(res.message);
                    }
                })
            },
            subFeedback(){
                this.popupModel = true;
            },
            onRefresh() {
                // 清空列表数据
                this.finished = false;

                // 重新加载数据
                // 将 loading 设置为 true，表示处于加载状态
                this.loading = true;
                this.onLoad();
            },
            onLoad() {
                setTimeout(() => {
                    if (this.refreshing) {
                        this.list = [];
                        this.refreshing = false;
                    }

                    for (let i = 0; i < 30; i++) {
                        this.list.push(this.list.length + 1);
                    }
                    this.loading = false;

                    if (this.list.length >= 40) {
                        this.finished = true;
                    }
                }, 1000);
            },
        }
    }
    </script>
    <style lang="less" scoped>
    .m-module {
        .section {
            .page-title {
                font-size:20px; font-weight:600; padding:30px 15px;
            }
            .pane {
                background:#fff; padding:15px;
                .hd {
                    padding:0 0 15px;
                    .nav{
                            padding:0 30px;
                            color: green;
                        }
                        .navRead{
                            padding:0 30px;
                            color: red;
                        }
                        .title{
                            font-size: 10px;
                            color:black;
                        }
                }
                /deep/.el-collapse-item__content {
                        text-align: center;
                    }
               
            }
          
        }
    }

    .tabbar-placeholder {
        height:54px;
    }
    .tabbar {
        position:fixed; left:0; bottom:0; right:0; height:54px; background:#fff; box-shadow:0 0 8px rgba(0,0,0,.08);
        .tabbar-inner {
            padding:5px 15px;
            &.u-flex {
                display:flex; justify-content: space-between; align-items: center;
                .u-flex-item {
                    &:first-child {margin-right:7px;}
                    &:last-child {margin-left:8px;}
                }
                .u-flex-1 {
                    flex:1;
                }
                .u-flex-2 {
                    flex:2;
                }
            }
        }
    }
    .popup-mod{
        .hd{
            font-size: 14px;
            line-height: 30px;
            text-align: center;
        }
        .bd{
            .uploader{
                padding: 10px 0 62px 15px;
            }
        }
    }
    </style>